// src/components/Travel/GoogleMapsEmbed.tsx
import React from "react";

import "./style.css";

interface GoogleMapsEmbedProps {
    embedID: string;
}

const GoogleMapsEmbed: React.FC<GoogleMapsEmbedProps> = ({ embedID }) => (
    <div className="container-iframe google-maps-container">
        <iframe 
            src={`https://www.google.com/maps/d/embed?mid=${embedID}&ehbc=2E312F`}
            className="responsive-iframe"
            title="Google Maps embed"
        />
    </div>
);

export default GoogleMapsEmbed;

